import { capitalize } from 'vue';

import i18n from '@/vueI18n';

enum UnitPlayerSyncStatus {
  PENDING_FIRST_SYNC = 1,
  SYNCED = 2,
  FAILED = 3,
  PENDING_UPDATE_SYNC = 4, // Unit was synced in the past, but details have to be updated
}

export interface IUnitPlayerIntegrationAPI {
  sync_status: UnitPlayerSyncStatus;
  uid: string;
  unit_id: number;
  unitplayerintegration_id: number;
}

export class UnitPlayerIntegration {
  constructor(
    public syncStatus: UnitPlayerSyncStatus,
    public uid: string,
    public unitId: number,
    public unitPlayerIntegrationId: number,
  ) {}

  static fromApi(api: IUnitPlayerIntegrationAPI): UnitPlayerIntegration {
    return new UnitPlayerIntegration(api.sync_status, api.uid, api.unit_id, api.unitplayerintegration_id);
  }

  get syncStatusFormatted(): string {
    switch (this.syncStatus) {
      case UnitPlayerSyncStatus.SYNCED:
        return capitalize(i18n.global.t('states.synced'));
      case UnitPlayerSyncStatus.FAILED:
        return capitalize(i18n.global.t('states.failed'));
      default:
        return capitalize(i18n.global.t('states.pending'));
    }
  }
}
